"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.workloadCountMapper = exports.workloadServiceStatus = exports.workloadPatientStatus = exports.appUserInfoMapper = exports.makeFakeUserInfo = void 0;
exports.userDirectoryMapper = userDirectoryMapper;
exports.appDirectoryMapper = appDirectoryMapper;
const UserInfoMapper_1 = require("./UserInfoMapper");
const models_1 = require("../models");
function userDirectoryMapper(userDirectoryDataResponse) {
    return userDirectoryDataResponse.map((userDirectory) => (0, UserInfoMapper_1.userInfoMapper)(userDirectory));
}
function appDirectoryMapper(appDirectoryDataResponse, organizationId) {
    return appDirectoryDataResponse.map((appDirectory) => {
        // Parse firstName and lastName from appDirectory.name
        let firstName = "";
        let lastName = "";
        if (appDirectory.name) {
            const nameParts = appDirectory.name.split(" ");
            firstName = nameParts[0] || "";
            lastName = nameParts.length > 1 ? nameParts.slice(1).join(" ") : "";
        }
        const senderInfo = {
            _id: appDirectory._id,
            appName: appDirectory.name,
            firstName,
            lastName,
            status: models_1.USER_STATUS.ACTIVE,
        };
        return (0, exports.appUserInfoMapper)(senderInfo, organizationId);
    });
}
const makeFakeUserInfo = (organizationId) => {
    return {
        about: "",
        firstName: "Unknown",
        groupType: models_1.GROUP_TYPE.PRIVATE,
        chatType: models_1.CHAT_TYPE.PRIVATE,
        id: "unknownUserId",
        image: "",
        lastName: "User",
        name: "Unknown User",
        organizationId,
        status: models_1.USER_STATUS.ACTIVE,
        title: "Unknown User",
        type: models_1.USER_TYPE.USER,
    };
};
exports.makeFakeUserInfo = makeFakeUserInfo;
const appUserInfoMapper = (senderInfo, organizationId) => {
    return {
        about: "",
        firstName: senderInfo.firstName,
        groupType: models_1.GROUP_TYPE.PRIVATE,
        chatType: models_1.CHAT_TYPE.PRIVATE,
        id: senderInfo._id,
        image: "",
        lastName: senderInfo.lastName,
        name: senderInfo.appName,
        organizationId,
        status: models_1.USER_STATUS[senderInfo.status],
        title: senderInfo.appName,
        type: models_1.USER_TYPE.APP,
    };
};
exports.appUserInfoMapper = appUserInfoMapper;
exports.workloadPatientStatus = {
    [models_1.PATIENT_STATUS.PENDING_SOC]: "pendingSoc",
    [models_1.PATIENT_STATUS.HOSPITALIZED]: "hospitalized",
    [models_1.PATIENT_STATUS.PENDING_ROC]: "pendingRoc",
    [models_1.PATIENT_STATUS.ACTIVE]: "socTotal",
};
exports.workloadServiceStatus = {
    [models_1.SERVICE_STATUS.ACTIVE]: "socActive",
    [models_1.SERVICE_STATUS.PENDING]: "socPending",
    [models_1.SERVICE_STATUS.DISCHARGED]: "socDischarged",
};
function getWorkloadCount(department) {
    return (workloadCounts, patient) => {
        const patientStatusKey = exports.workloadPatientStatus[String(patient.patientStatus)];
        patientStatusKey &&
            workloadCounts[patientStatusKey]++;
        if (patientStatusKey === exports.workloadPatientStatus[models_1.PATIENT_STATUS.ACTIVE]) {
            patient.servicesToPatient.map((service) => {
                const serviceStatusKey = exports.workloadServiceStatus[String(service.status)];
                department === service.shorthand &&
                    serviceStatusKey &&
                    workloadCounts[serviceStatusKey]++;
            });
        }
        return workloadCounts;
    };
}
const workloadCountMapper = (userWorkloadData, userInfo) => {
    var _a;
    const { patients } = userWorkloadData;
    const department = (_a = userInfo.department) === null || _a === void 0 ? void 0 : _a.shortHand;
    const initialWorkloadCounts = {
        pendingSoc: 0,
        hospitalized: 0,
        pendingRoc: 0,
        socTotal: 0,
        socActive: 0,
        socPending: 0,
        socDischarged: 0,
    };
    const getWorkloadCountWithDepartment = (department) => getWorkloadCount(department);
    return patients.reduce(getWorkloadCountWithDepartment(department), initialWorkloadCounts);
};
exports.workloadCountMapper = workloadCountMapper;
